// extracted by mini-css-extract-plugin
module.exports = {"colorD20":"ReviewSubjectLink_colorD20__aC_0P"};